<template>
  <UserList :technician-management="true" />
</template>

<script>
import UserList from "./UserList.vue";

export default {
  name: "TechnicianList",
  components: { UserList },
};
</script>
